module.exports = __webpack_public_path__ + "media/images/img/seikousya/deloito-19d3f6df5cca6b10c3b63f8236470fda.png";